<template>
	<TsPanelCustomScroll :loading="loading">
		<ts-page-title :title="$t('driverProfile.pageTitle')" :breadcrumb="[
			{ text: $t('home'), href: '/' },
			{
				text: $t('driverProfile.pageTitle'),
				href: '/admin/driver/driver-profiles'
			},
			{
				text: $t('create'),
				active: true
			}
		]" />
		<div class="row">
			<div class="col-md-12 tw-space-y-3">
				<ts-panel>
					<ts-panel-wrapper class="tw-space-y-2">
						<div class="row">
							<div class="col-md-6 tw-space-y-2">
								<!-- personal-info -->
								<PersonalInfo v-model="model" :validate="errors" ref="personalinfo" />

								<!-- id or passport -->
								<IdOrPassport v-model="model" :validate="errors" />
							</div>
							<div class="col-md-6 tw-space-y-2">
								<!-- vehicle license -->
								<VehicleLicense v-model="model" :validate="errors" />

								<!-- bank profiles -->
								<BankAccount v-model="model" :validate="errors" />
							</div>
						</div>
					</ts-panel-wrapper>
				</ts-panel>
				<div class="tw-grid lg:tw-grid-cols-3 sm:tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3">
					<!-- <div class="tw-w-full">
                        <FeeSetup
                            v-model="model"
                            :validate="errors"
                        />
                    </div> -->
					<div class="tw-w-full">
						<!-- place of birth -->
						<PlaceOfBirth v-model="model" :validate="errors" @loading="v => (loading = v)" />
					</div>
					<div class="tw-w-full">
						<!-- current address -->
						<CurrentAddress v-model="model" :validate="errors" @loading="v => (loading = v)" />
					</div>
					<div class="tw-w-full">
						<!-- user -->
						<User v-model="model" :validate="errors" />
					</div>
				</div>
				<div class="row tw-space-y-4 sm:tw-space-y-0 lg:tw-space-y-0">
					<div class="col-md-12">
						<FeeSetup v-model="model" :validate="errors" />
					</div>
				</div>
				<div class="row tw-space-y-4 sm:tw-space-y-0 lg:tw-space-y-0">
					<div class="col-md-12">
						<Schedule v-model="model" :validate="errors" />
					</div>
				</div>
			</div>
		</div>
		<br />
		<template v-slot:footer>
			<ts-button @click.prevent="$router.push({ name: 'driver-profile' })" :disabled="loading">{{ $t('cancel')
				}}</ts-button>
			<ts-button color="primary" outline @click.prevent="onSaveAddNew" :disabled="loading">{{ $t('saveAddNew')
				}}</ts-button>
			<ts-button color="primary" @click.prevent="onSave" :disabled="loading">{{ $t('save') }}</ts-button>
		</template>
	</TsPanelCustomScroll>
</template>

<script>
import { Errors } from 'form-backend-validation'
import PersonalInfo from './components/personal-info.vue'
import IdOrPassport from './components/id-or-passport.vue'
import VehicleLicense from './components/vehicle-license.vue'
import BankAccount from './components/bank-account.vue'
import PlaceOfBirth from './components/place-of-birth.vue'
import CurrentAddress from './components/current-address.vue'
import User from './components/user.vue'
import FeeSetup from './components/fee.vue'
import Schedule from './components/schedule.vue'

import { mapActions } from 'vuex'

export default {
	name: 'driverProfileCreate',
	components: {
		PersonalInfo,
		IdOrPassport,
		VehicleLicense,
		BankAccount,
		PlaceOfBirth,
		CurrentAddress,
		User,
		FeeSetup,
		Schedule
	},
	data() {
		return {
			errors: new Errors(),
			loading: false,
			model: {
				driver_id: '',
				driver_code: '',
				driver_name: '',
				photo: '',
				sex: '',
				dob: undefined,
				phone1: '',
				phone2: '',
				phone3: '',
				id_passport_no: '',
				id_passport_issue_date: undefined,
				id_passport_expiry_date: undefined,
				emergency_contact: '',
				emergency_relationship: '',
				contract_start_date: undefined,
				contract_end_date: undefined,
				is_internal_driver: false,
				is_active: true,
				agency_id: undefined,
				province_code: undefined,
				district_code: undefined,
				commune_code: undefined,
				village_code: undefined,
				pob_province_code: undefined,
				pob_district_code: undefined,
				pob_commune_code: undefined,
				pob_village_code: undefined,
				plat_number: '',
				vehicle_type_id: undefined,
				driver_license_no: '',
				driver_license_issue_date: '',
				driver_license_expiry_date: '',
				guarantor1: '',
				guarantor1_phone: '',
				guarantor2: '',
				guarantor2_phone: '',
				bank_id: undefined,
				bank_acc_number: '',
				bank_acc_name: '',
				user_name: '',
				password: null,
				password_confirmation: null,

				pickup_fee: 0,
				express_vip_delivery_fee: null,
				express_vip_delivery_fee_type: '$',
				express_normal_delivery_fee: null,
				express_normal_delivery_fee_type: '$',
				standard_vip_delivery_fee: null,
				standard_vip_delivery_fee_type: '$',
				standard_normal_delivery_fee: null,
				standard_normal_delivery_fee_type: '$',

				sch_monday: true,
				sch_tuesday: true,
				sch_wednesday: true,
				sch_thursday: true,
				sch_friday: true,
				sch_saturday: true,
				sch_sunday: true,
				sch_start_time: null,
				sch_stop_time: null,
				vehicle_color: null,

				is_global_fee: true,
				driver_fees: []
			}
		}
	},
	methods: {
		...mapActions('driver/driverProfile', ['getFormViewData']),
		async fetchFormView(params) {
			this.loading = true
			await this.getFormViewData({ params: params })
				.catch(err => {
					this.$notify({ type: 'error', text: err.message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		onSaveAddNew() {
			this.errors = new Errors()
			this.loading = true
			this.$store
				.dispatch('driver/driverProfile/store', this.model)
				.then(async response => {
					await this.uploadLogo(response.driver_id)
					this.$notify({ type: 'success', text: response.message })
					this.clearInput()
				})
				.catch(error => {
					this.errors = new Errors(error.errors)
					this.$notify({ type: 'error', text: error.message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		onSave() {
			this.errors = new Errors()
			this.loading = true
			this.$store
				.dispatch('driver/driverProfile/store', this.model)
				.then(async response => {
					await this.uploadLogo(response.driver_id)
					this.$notify({ type: 'success', text: response.message })
					this.$router.push({ name: 'driver-profile' })
				})
				.catch(error => {
					this.errors = new Errors(error.errors)
					this.$notify({ type: 'error', text: error.message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		async uploadLogo(driverId) {
			if (this.model.photo instanceof File) {
				let formData = new FormData()
				formData.append('file', this.model.photo)
				formData.append('driver_id', driverId)
				let response = await this.$store.dispatch(
					'driver/driverProfile/upload',
					formData
				)
				return response
			}
			return ''
		},
		clearInput() {
			this.model.driver_id = ''
			this.model.driver_code = ''
			this.model.driver_name = ''
			this.model.photo = ''
			this.model.sex = ''
			this.model.dob = undefined
			this.model.phone1 = ''
			this.model.phone2 = ''
			this.model.id_passport_no = ''
			this.model.id_passport_issue_date = undefined
			this.model.id_passport_expiry_date = undefined
			this.model.emergency_contact = ''
			this.model.emergency_relationship = ''
			this.model.contract_start_date = undefined
			this.model.contract_end_date = undefined
			this.model.is_internal_driver = false
			this.model.is_active = true
			this.model.agency_id = undefined
			this.model.province_code = undefined
			this.model.district_code = undefined
			this.model.commune_code = undefined
			this.model.village_code = undefined
			this.model.pob_province_code = undefined
			this.model.pob_district_code = undefined
			this.model.pob_commune_code = undefined
			this.model.pob_village_code = undefined
			this.model.plat_number = ''
			this.model.vehicle_type_id = undefined
			this.model.driver_license_no = ''
			this.model.driver_license_issue_date = ''
			this.model.driver_license_expiry_date = ''
			this.model.guarantor1 = ''
			this.model.guarantor1_phone = ''
			this.model.guarantor2 = ''
			this.model.guarantor2_phone = ''
			this.model.bank_id = undefined
			this.model.bank_acc_number = ''
			this.model.bank_acc_name = ''
			this.model.user_name = ''
			this.model.password = null
			this.model.vehicle_color = null
			this.model.password_confirmation = null
			this.$refs.personalinfo.$refs.uploadimage.logo_file = ''
			this.$refs.personalinfo.$refs.uploadimage.logo_file_src = require('@/assets/default-image.jpg')
			this.model.pickup_fee = 0
			this.model.express_vip_delivery_fee = null
			this.model.express_vip_delivery_fee_type = '$'
			this.model.express_normal_delivery_fee = null
			this.model.express_normal_delivery_fee_type = '$'
			this.model.standard_vip_delivery_fee = null
			this.model.standard_vip_delivery_fee_type = '$'
			this.model.standard_normal_delivery_fee = null
			this.model.standard_normal_delivery_fee_type = '$'
			this.model.sch_monday = true
			this.model.sch_tuesday = true
			this.model.sch_wednesday = true
			this.model.sch_thursday = true
			this.model.sch_friday = true
			this.model.sch_saturday = true
			this.model.sch_sunday = true
			this.model.sch_start_time = null
			this.model.sch_stop_time = null
			this.model.vehicle_color = null
			this.model.is_global_fee = true
			this.model.driver_fees = []
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fetchFormView()
		})
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit('driver/driverProfile/RESET_STATE')
		next()
	}
}
</script>
